"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedMediaLightDefault = void 0;
var _react = _interopRequireDefault(require("react"));
var FeaturedMediaLightDefault = exports.FeaturedMediaLightDefault = function FeaturedMediaLightDefault() {
  return _react["default"].createElement("svg", {
    width: "96",
    height: "54",
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    width: "96",
    height: "54",
    fill: "#6E7391"
  }), _react["default"].createElement("rect", {
    x: "7",
    y: "7",
    width: "24",
    height: "12",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M19 13C20.0938 13 21 12.1094 21 11C21 9.90625 20.0938 9 19 9C17.8906 9 17 9.90625 17 11C17 12.1094 17.8906 13 19 13ZM20.3906 13.5H20.125C19.7812 13.6719 19.4062 13.75 19 13.75C18.5938 13.75 18.2031 13.6719 17.8594 13.5H17.5938C16.4375 13.5 15.5 14.4531 15.5 15.6094V16.25C15.5 16.6719 15.8281 17 16.25 17H21.75C22.1562 17 22.5 16.6719 22.5 16.25V15.6094C22.5 14.4531 21.5469 13.5 20.3906 13.5Z",
    fill: "#5C617C"
  }), _react["default"].createElement("rect", {
    x: "7",
    y: "21",
    width: "24",
    height: "12",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M19 27C20.0938 27 21 26.1094 21 25C21 23.9062 20.0938 23 19 23C17.8906 23 17 23.9062 17 25C17 26.1094 17.8906 27 19 27ZM20.3906 27.5H20.125C19.7812 27.6719 19.4062 27.75 19 27.75C18.5938 27.75 18.2031 27.6719 17.8594 27.5H17.5938C16.4375 27.5 15.5 28.4531 15.5 29.6094V30.25C15.5 30.6719 15.8281 31 16.25 31H21.75C22.1562 31 22.5 30.6719 22.5 30.25V29.6094C22.5 28.4531 21.5469 27.5 20.3906 27.5Z",
    fill: "#5C617C"
  }), _react["default"].createElement("rect", {
    x: "7",
    y: "35",
    width: "24",
    height: "12",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M19 41C20.0938 41 21 40.1094 21 39C21 37.9062 20.0938 37 19 37C17.8906 37 17 37.9062 17 39C17 40.1094 17.8906 41 19 41ZM20.3906 41.5H20.125C19.7812 41.6719 19.4062 41.75 19 41.75C18.5938 41.75 18.2031 41.6719 17.8594 41.5H17.5938C16.4375 41.5 15.5 42.4531 15.5 43.6094V44.25C15.5 44.6719 15.8281 45 16.25 45H21.75C22.1562 45 22.5 44.6719 22.5 44.25V43.6094C22.5 42.4531 21.5469 41.5 20.3906 41.5Z",
    fill: "#5C617C"
  }), _react["default"].createElement("rect", {
    x: "33",
    y: "7",
    width: "56",
    height: "40",
    rx: "2",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M65.6875 26.5391L57.4375 21.6641C56.7578 21.2656 55.75 21.6641 55.75 22.625V32.375C55.75 33.2656 56.6875 33.8047 57.4375 33.3594L65.6875 28.4844C66.4141 28.0391 66.4141 26.9844 65.6875 26.5391Z",
    fill: "#5C617C"
  }));
};